<template>
  <v-textarea
    :rules="rules"
    v-bind="[fieldProps, $attrs]"
    label="Mensagem"
    name="message"
    no-resize
  ></v-textarea>
</template>

<script>
import { requiredValidation } from "../validations/requiredValidation";
import { mixin } from "./mixin";

export default {
  data: () => ({
    rules: [requiredValidation("Digite a mensagem.")],
  }),
  mixins: [mixin],
};
</script>
